/**! Qoopido.demand 5.0.1-alpha.2 | https://github.com/dlueth/qoopido.demand | (c) 2018 Dirk Lueth */
(function (document) {
	"use strict";

	function definition(path, iterate, isObject, isTypeOf) {
		function setCookie(dependency, value, expiration) {
			if (enabled || isEnabled(dependency.path)) document.cookie = "demand[" + dependency.type + "][" + dependency.path + "]=" + encodeURIComponent(value) + "; expires=" + expiration + "; path=/"
		}

		function isEnabled(path) {
			for (var pointer, match, i = 0; pointer = pattern[i]; i++)
				if (0 === path.indexOf(pointer.pattern) && (!match || pointer.weight > match.weight)) match = pointer;
			return match ? match.state : false
		}
		var enabled, past = "Thu, 01 Jan 1970 00:00:00 GMT",
			future = "Fri, 31 Dec 9999 23:59:59 GMT",
			pattern = [];
		demand.on("postConfigure:" + path, function (options) {
				if (isObject(options)) {
					pattern.length = 0;
					iterate(options, function (key, value) {
						pattern.push({
							pattern: key,
							weight: key.length,
							state: value
						})
					})
				} else if (isTypeOf(options, "boolean")) enabled = options
			})
			.on("cacheMiss", function (dependency) {
				setCookie(dependency, "", past)
			})
			.on("cacheClear", function (dependency) {
				setCookie(dependency, "", past)
			})
			.on("postCache", function (dependency, state) {
				setCookie(dependency, JSON.stringify(state), future)
			});
		return true
	}
	provide(["path", "/demand/function/iterate", "/demand/validator/isObject", "/demand/validator/isTypeOf"], definition)
})(document);
